<template>
  <div class="paymentDetails">
    <v-row>
      <v-col>
        
        <v-form
          ref="form"
          id="payment_form"
          class="payment-form"
          action="https://api.moyasar.com/v1/payments.html"
          method="POST"
          v-model="valid"
        >
          <input
            type="hidden"
            name="callback_url"
            :value="jawabUrl + '/market/payments/redirect/' + paymentId"
          />
          <input
            type="hidden"
            name="publishable_api_key"
            value="pk_test_wN6smrbt6zp7HvaHz56KenxVSihwpVefQbJft7RK"
          />
          <input
            type="hidden"
            name="amount"
            :value="parseInt(subTotal + 10) * 100"
          />
          <input type="hidden" name="description" value="Mothaber Payment" />
          <input type="hidden" name="source[type]" value="creditcard" />

          <v-row>
            <v-col cols="12" sm="12" md="12" class="payment-methods-row">
              <v-radio-group
                row
                v-model="paymentData.payment_method"
                :rules="[validationRules.required]"
              >
                <v-radio label="$t('فيزا')" value="visa">
                  <template v-slot:label>
                    <img
                      src="../../assets/images/visa.jpg"
                      width="80px"
                      alt="visa"
                      class="payment-method"
                      :class="
                        paymentData.payment_method == 'visa' ? 'active' : ''
                      "
                    />
                  </template>
                </v-radio>
                <v-radio label="$t('masterCard')" value="mastercard">
                  <template v-slot:label>
                    <img
                      style="height: 56px"
                      src="../../assets/images/mastercard.png"
                      width="80px"
                      alt="visa"
                      class="payment-method"
                      :class="
                        paymentData.payment_method == 'mastercard'
                          ? 'active'
                          : ''
                      "
                    />
                  </template>
                </v-radio>
                <v-radio label="$t('mada')" value="mada">
                  <template v-slot:label>
                    <img
                      style="width: 80px; height: 50px"
                      src="../../assets/images/Mada_Logo.svg"
                      width="100px"
                      alt="visa"
                      class="payment-method"
                      :class="
                        paymentData.payment_method == 'mada' ? 'active' : ''
                      "
                    />
                  </template>
                </v-radio>
              </v-radio-group>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" sm="3" md="3">
              <label class="main-color" for="name"
                >{{ $t("cardNumber") }} *</label
              >
            </v-col>
            <v-col cols="12" sm="9" md="9">
              <v-text-field
                name="source[number]"
                solo
                :rules="[
                  validationRules.required,
                  validationRules.numeric,
                  validationRules.maxLength16,
                ]"
                v-model="paymentData.card_number"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" sm="3" md="3">
              <label class="main-color" for="name"
                >{{ $t("cardName") }} *</label
              >
            </v-col>
            <v-col cols="12" sm="9" md="9">
              <v-text-field
                name="source[name]"
                solo
                v-model="paymentData.card_holder_name"
                :rules="[
                  validationRules.required,
                  validationRules.spaces,
                  checkcardName(paymentData.card_holder_name),
                ]"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" sm="3" md="3">
              <label class="main-color" for="name"
                >{{ $t("Expired Date") }} *</label
              >
            </v-col>
            <v-col cols="12" sm="9" md="9">
              <v-row>
                <v-col cols="12" sm="4" md="4" class="input-inline">
                  <label class="label-style" for="name"
                    >{{ $t("CVV") }} *</label
                  >
                  <v-text-field
                    name="source[cvc]"
                    :rules="[
                      validationRules.required,
                      validationRules.numeric,
                      validationRules.maxLength3,
                    ]"
                    solo
                    v-model="paymentData.cvc"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="4" md="4" class="input-inline">
                  <label class="label-style" 
                    for="month"
                    :style="(locale == 'en') ? 'min-width: 50px !important' : ''"
                    >{{ $t("month") }} *</label
                  >
                  <v-select
                    
                    name="source[month]"
                    :items="months"
                    :rules="[
                      validationRules.required,
                      checkDate(paymentData.exp_year, paymentData.exp_month),
                    ]"
                    solo
                    v-model="paymentData.exp_month"
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="4" md="4" class="input-inline">
                  <label class="label-style" for="year"
                    >{{ $t("year") }} *</label
                  >
                  <v-select
                    name="source[year]"
                    :rules="[
                      validationRules.required,
                      checkDate(paymentData.exp_year, paymentData.exp_month),
                    ]"
                    solo
                    :items="years"
                    v-model="paymentData.exp_year"
                  ></v-select>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="text-center">
              <v-btn
                class="primary-btn-submit-payment"
                @click="submitPayment"
                >
                <v-icon color="#ffffff" medium style="margin-left: 5px">payment</v-icon>
                 {{ $t("confirmPayment") }}
               
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-col>
    </v-row>
    <!-- success dialog -->
    <v-dialog v-model="paymentDialog" max-width="500">
      <v-card>
        <v-card-title class="headline main-color">
          {{ $t("please_wait") }}
        </v-card-title>

        <div>
          <v-container style="padding: 1rem !important">
            <v-row>
              <v-col>
                <p class="text-center grey--text darken">
                  {{ $t("payment_redirect_msg") }}
                </p>
                <p class="text-center grey--text darken">{{ countDown }}</p>
              </v-col>
            </v-row>
          </v-container>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { validationMixin } from "../../mixins/validationMixin";

export default {
  name: "PaymentDetailsComponent",
  mixins: [validationMixin],
  props: {
    // addresses: {
    //   type: Array,
    //   required: true
    // },
    // countries: {
    //   type: Array,
    //   required: true
    // },
    // cities: {
    //   type: Array,
    //   required: true
    // }
    user_city_id: {
      type: Number,
      require: true,
    },
    address_id: {
      type: Number,
      require: true,
    },
  },

  data() {
    return {
      valid: false,

      jawabUrl: window.location.origin,
      paymentId: "",
      subTotal: "",
      paymentDialog: false,
      countDown: 3,
      years: [],
      months: [
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12",
      ],
      paymentData: {
        payment_method: "",
        card_number: "",
        card_holder_name: "",
        cvc: "",
        exp_month: "",
        exp_year: "",
        cartID:
          localStorage.cartID && localStorage.cartID != undefined
            ? localStorage.cartID
            : "",
        address_id: 0,
        user_city_id: "",
      },
    };
  },
  methods: {
    submitPayment() {
      if (this.valid == false) {
        this.validate();
        // this.$refs.addressForm.validate();
      } else {
        //create payment
        this.$http
          .post(this.getApiUrl + "/market/checkout", this.paymentData, {
            headers: {
              locale: localStorage.locale,
              Authorization: "Bearer " + localStorage.token,
            },
          })
          .then((res) => {
            if (res.data.status.error == false) {
              this.paymentId = res.data.data.payment_id;
              this.paymentDialog = true;
              this.countDownTimer();
              // finally submit form
            }
          });
      }
    },
    countDownTimer() {
      if (this.countDown > 0) {
        setTimeout(() => {
          this.countDown -= 1;
          this.countDownTimer();
        }, 1000);
      } else {
        document.getElementById("payment_form").submit();
        this.paymentDialog = false;
      }
    },
    generateYears() {
      const currentYear = new Date().getFullYear();
      for (let i = currentYear; i <= currentYear + 8; i++) {
        this.years.push(i.toString());
      }
    },

    getCheckoutData() {
      this.$http
        .get(
          this.getApiUrl +
            "/market/checkout?cartID=" +
            (localStorage.cartID && localStorage.cartID != undefined
              ? localStorage.cartID
              : ""),
          {
            headers: {
              Authorization: "Bearer " + localStorage.token,
              locale: localStorage.locale,
            },
          }
        )
        .then((response) => {
          if (response.data.status.error == false) {
            this.subTotal = response.data.data.order.subTotal;
            this.paymentData.user_city_id = this.user_city_id;
            this.paymentData.address_id = this.address_id;
            if (Object.keys(response.data.data.payment_data).length > 0) {
              this.paymentData.payment_method =
                response.data.data.payment_data.payment_method;

              this.paymentData.card_number =
                response.data.data.payment_data.card_number;

              this.paymentData.card_holder_name =
                response.data.data.payment_data.card_holder_name;

              this.paymentData.cvc = response.data.data.payment_data.cvc;

              this.paymentData.exp_month =
                response.data.data.payment_data.exp_month;

              this.paymentData.exp_year =
                response.data.data.payment_data.exp_year;
            }
          }
        });
    },
  },
  mounted() {
    this.generateYears();
    this.getCheckoutData();
  },
};
</script>

<style lang="scss" scoped>
.paymentDetails {
  padding: 2rem;
  background: #f5f5f6;
  margin: 2rem;
}
.payment-methods-row {
  display: flex;
  justify-content: center;
}
.input-inline {
  display: flex;

  .label-style {
    margin-left: 8px;
    color: gray;
    width: 53px;
  }
}
button.primary-btn-submit-payment.v-btn.v-btn--contained.theme--light.v-size--default {
  width: 50%;
  background-color: #10a8b1;
  color: #fff;
  padding: 24px 0px;
}
.payment-method.active {
  border: 3px solid #ffbc00;
}
.label-style {
  font-size: .8rem !important
}
</style>
